package app.nestbridge.config

import kotlin.Boolean
import kotlin.Int
import kotlin.String

internal object BuildKonfig {
  public val applicationId: String = "app.nestbridge.stg"

  public val identityServiceUrl: String = "https://identity.api-stg.nestbridge.app"

  public val childServiceUrl: String = "https://child.api-stg.nestbridge.app"

  public val stytchPublicToken: String = "public-token-test-31ca7083-7d3e-4267-bf22-27b2ce0078de"

  public val googleClientId: String =
      "661307489300-j4juu08t5fpjtenrrnn23seunvf2i608.apps.googleusercontent.com"

  public val stytchTokenExpirationMinutes: Int = 5

  public val stytchSessionDurationMinutes: Int = 6

  public val sessionInactivityMinutes: Int = 3

  public val stytchOauthCallbackPort: Int = 7800

  public val passkeyDomain: String = "stg.nestbridge.app"

  public val useLocalAuthenticator: Boolean = false

  public val httpLogLevel: String = "ALL"

  public val sentryDsn: String =
      "https://ac3f1b2e77f6348fad91ab9463d956d2@o4510937275039744.ingest.us.sentry.io/4511572545044480"

  public val sentryDebug: Boolean = false

  public val sentryTracesSampleRate: String = "0.5"

  public val httpMaxRetries: Int = 3
}
